import { render, staticRenderFns } from "./MedicalContentTemplatesPopup.vue?vue&type=template&id=6a098561&scoped=true&"
import script from "./MedicalContentTemplatesPopup.vue?vue&type=script&lang=js&"
export * from "./MedicalContentTemplatesPopup.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentTemplatesPopup.vue?vue&type=style&index=0&id=6a098561&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a098561",
  null
  
)

export default component.exports